<div class="d-flex px-2">
    <div class="card bg-white mx-auto my-4 w-100 shadow">
        <h1 class="card-title p-4">You do not have permission to access this page</h1>
    </div>
</div>
